import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import {
  ChargeAppointmentFragment,
  GetChargeAppointmentDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchAppointment = (
  appointmentId: string | null,
): ChargeAppointmentFragment | undefined => {
  const [getAppointment, { data }] = useLazyQuery(GetChargeAppointmentDocument, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (appointmentId) {
      getAppointment({
        variables: {
          id: appointmentId,
        },
      });
    }
  }, [appointmentId, getAppointment]);

  return getNode(data, 'Appointment');
};
